// Membership Calculator Alpine.js Component
document.addEventListener('alpine:init', () => {
    Alpine.data('membershipCalculator', () => ({
        // Input values
        hectares: 0,
        tonnes: 0,
        wineSales: 0,
        showResults: false,

        // Constants
        HECTARE_RATE: 10.17,
        TONNE_RATE: 0.87,
        SALES_RATE: 0.00427,
        GST_RATE: 0.1,
        MIN_SUBSCRIPTION: 770.00,
        MAX_SUBSCRIPTION: 30787.00,

        init() {
            this.resetCalculator();
            this.$nextTick(() => {
                this.initTooltips();
            });
        },

        initTooltips() {
            if (window.tippy) {
                window.tippy('[data-tippy-content]', {
                    theme: 'light',
                    placement: 'top',
                    arrow: true,
                    maxWidth: 200,
                });
            }
        },

        // Computed properties
        get sectionA() {
            return this.hectares * this.HECTARE_RATE;
        },

        get sectionB() {
            return this.tonnes * this.TONNE_RATE;
        },

        get sectionC() {
            return this.wineSales * this.SALES_RATE;
        },

        get subtotal() {
            return this.sectionA + this.sectionB + this.sectionC;
        },

        get finalExGST() {
            const limited = Math.max(this.MIN_SUBSCRIPTION, Math.min(this.MAX_SUBSCRIPTION, this.subtotal));
            return limited;
        },

        get gstAmount() {
            return this.finalExGST * this.GST_RATE;
        },

        get finalIncGST() {
            return this.finalExGST + this.gstAmount;
        },

        get isAtMinimum() {
            return this.subtotal < this.MIN_SUBSCRIPTION;
        },

        get isAtMaximum() {
            return this.subtotal > this.MAX_SUBSCRIPTION;
        },

        // Methods
        resetCalculator() {
            this.hectares = 0;
            this.tonnes = 0;
            this.wineSales = 0;
            this.showResults = false;
        },

        formatCurrency(amount) {
            return new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: 'AUD',
                minimumFractionDigits: 2
            }).format(amount);
        },

        formatNumber(number, decimals = 0) {
            return new Intl.NumberFormat('en-AU', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            }).format(number);
        },

        // Init Form
        initForm() {
            try{
                var f = document.createElement("iframe");

                var ifrmSrc = `https://forms.zohopublic.com.au/winesa1/form/MembershipApplicationForm/formperma/tRXXdPqmYBigtNyrBX9SUUe9U_l8jWZOEjf0MwdEpIQ?zf_rszfm=1&ha=${this.hectares}&tonnes=${this.tonnes}&sales=${this.wineSales}&haTotal=${this.sectionA.toFixed(2)}&tonnesTotal=${this.sectionB.toFixed(2)}&salesTotal=${this.sectionC.toFixed(2)}&totalGSTexcl=${this.finalExGST.toFixed(2)}&totalGSTincl=${this.finalIncGST.toFixed(2)}&membershipCost=${this.finalIncGST.toFixed(2)}`;


                try{
                    if ( typeof ZFAdvLead != "undefined" && typeof zfutm_zfAdvLead != "undefined" ) {
                        for( var prmIdx = 0 ; prmIdx < ZFAdvLead.utmPNameArr.length ; prmIdx ++ ) {
                            var utmPm = ZFAdvLead.utmPNameArr[ prmIdx ];
                            utmPm = ( ZFAdvLead.isSameDomian && ( ZFAdvLead.utmcustPNameArr.indexOf(utmPm) == -1 ) ) ? "zf_" + utmPm : utmPm;
                            var utmVal = zfutm_zfAdvLead.zfautm_gC_enc( ZFAdvLead.utmPNameArr[ prmIdx ] );
                            if ( typeof utmVal !== "undefined" ) {
                            if ( utmVal != "" ) {
                                if(ifrmSrc.indexOf('?') > 0){
                                    ifrmSrc = ifrmSrc+'&'+utmPm+'='+utmVal;
                                }else{
                                    ifrmSrc = ifrmSrc+'?'+utmPm+'='+utmVal;
                                }
                            }
                            }
                        }
                    }
                    if ( typeof ZFLead !== "undefined" && typeof zfutm_zfLead !== "undefined" ) {
                        for( var prmIdx = 0 ; prmIdx < ZFLead.utmPNameArr.length ; prmIdx ++ ) {
                            var utmPm = ZFLead.utmPNameArr[ prmIdx ];
                            var utmVal = zfutm_zfLead.zfutm_gC_enc( ZFLead.utmPNameArr[ prmIdx ] );
                            if ( typeof utmVal !== "undefined" ) {
                            if ( utmVal != "" ){
                                if(ifrmSrc.indexOf('?') > 0){
                                ifrmSrc = ifrmSrc+'&'+utmPm+'='+utmVal;//No I18N
                                }else{
                                ifrmSrc = ifrmSrc+'?'+utmPm+'='+utmVal;//No I18N
                                }
                            }
                            }
                        }
                    }
                }catch(e){}

                f.src = ifrmSrc;
                f.style.border="none";
                f.style.height="2205px";
                f.style.width="90%";
                f.style.transition="all 0.5s ease";
                f.setAttribute("aria-label", 'Membership Application Form');

                var d = document.getElementById("zoho-form");
                d.innerHTML = '';
                d.appendChild(f);
                window.addEventListener('message', function (){
                    var evntData = event.data;
                    if( evntData && evntData.constructor == String ){
                        var zf_ifrm_data = evntData.split("|");
                        if ( zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3 ) {
                            var zf_perma = zf_ifrm_data[0];
                            var zf_ifrm_ht_nw = ( parseInt(zf_ifrm_data[1], 10) + 15 ) + "px";
                            var iframe = document.getElementById("zoho-form").getElementsByTagName("iframe")[0];
                            if ( (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0 ) {
                                var prevIframeHeight = iframe.style.height;
                                var zf_tout = false;
                                if( zf_ifrm_data.length == 3 ) {
                                    iframe.scrollIntoView();
                                    zf_tout = true;
                                }

                                if ( prevIframeHeight != zf_ifrm_ht_nw ) {
                                    if( zf_tout ) {
                                        setTimeout(function(){
                                            iframe.style.height = zf_ifrm_ht_nw;
                                        },500);
                                    } else {
                                        iframe.style.height = zf_ifrm_ht_nw;
                                    }
                                }
                            }
                        }
                    }
                }, false);
            }catch(e){}
        }
    }));
});
